"use client";

import { useOnborda } from "onborda";

import { ProgressBarLink } from "@/components/progress-bar";

import { useUser } from "@/contexts/user-provider";

/**
 * Body of the unread-chats tour. While the viewer's Mark Chats as Read When
 * Opened preference is off, it also points at it, which stops the backlog
 * building up again.
 */
export function UnreadChatsTourContent() {
  const { currentUser } = useUser();
  // The overlay outlives the page change and would cover the switch.
  const { closeOnborda } = useOnborda();

  return (
    <div className="space-y-2">
      <p>
        Hover a chat to tick it, then use Select all to mark them all as read.
      </p>
      {!currentUser?.markChatReadOnOpen && (
        <p>
          To stop them piling up, turn on Mark Chats as Read When Opened in{" "}
          <ProgressBarLink
            href="/settings/preferences"
            onClick={closeOnborda}
            className="font-medium text-foreground underline underline-offset-2"
          >
            your Preferences
          </ProgressBarLink>
          .
        </p>
      )}
    </div>
  );
}
